import React from "react";
import MainVideo from "../MainVideo";
import "./styles.scss";
import Title from "../Title";
import Banner from "../Banner";
import { useParams } from "react-router-dom";

const Hotels = () => {
  const { param } = useParams();

  return (
    <div className="Hotels-component">
      <MainVideo
        className="remove-extra"
        isFullScreen={true}
        video={[
          {
            autoPlay: true,
            link: "https://shrsl.com/40aii",
            title: "Chatrium Hotels & Residences",
            videoUrl: `https://shrslv.s3.amazonaws.com/126440/11CHR-15.mp4`,
          },
        ]}
      />
      <Title content={param?.replaceAll("-", " ")} position={"center"} />
      <Banner size="medium">
        <a target="_blank" href="https://shrsl.com/40clq">
          <img
            alt={"Chatrium Hotels & Residences"}
            src="https://static.shareasale.com/image/126440/CHR-Banner-2000x1500.jpg"
            border="0"
          />
        </a>
      </Banner>
    </div>
  );
};

export default Hotels;
